import React from 'react';
import { Box, Flex, Icon, Image } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Heading from '@/components/Heading';
import Text from '@/components/Text';
import withProps from '@/components/withProps';
import getAsset from '@/utils/getAsset';

const StyledContainer = withProps({
  flex: [null, null, '1'],
  maxWidth: ['100%', null, '370px'],
})(Box);

const StyledText = React.memo(({ text }) => (
  <Box mt={2}>
    <Text>{text}</Text>
  </Box>
));

const Banner = ({ slug }) => {
  if (!slug || slug !== 'fly-a-friend-for-free') {
    return null;
  }

  return (
    <Box pt={6}>
      <Box p={6} borderRadius="sm" border="1" borderColor="border">
        <Heading.h5
          fontSize={['base', null, 'md']}
          lineHeight={['22px', null, '25px']}
        >
          Fly a Friend for FREE^ – How it works
        </Heading.h5>
        <Flex
          justifyContent="space-between"
          flexDirection={['column', null, 'row']}
          mt={4}
        >
          <StyledContainer>
            <Box>
              <Image
                src={getAsset('/images/icons/friends_getaway.svg')}
                alt="friend-getaway"
                height="32px"
                width="32px"
              />
            </Box>
            <StyledText text="Book an eligible package and for each full paying passenger, an additional passenger can fly for free." />
          </StyledContainer>
          <StyledContainer mt={[10, null, 0]}>
            <Box>
              <Icon name="flights" color="primary" size={32} />
              <Icon name="add" color="primary" size={20} />
              <Icon name="accommodation" color="primary" size={32} />
            </Box>
            <StyledText text="The offer applies to single bookings, so all passengers must travel on the same flights and stay in the same hotel room, using available bedding configurations." />
          </StyledContainer>
          <StyledContainer mt={[10, null, 0]}>
            <Box>
              <Image
                src={getAsset('/images/icons/travel_dates.svg')}
                alt="travel-dates"
                height="32px"
                width="32px"
              />
            </Box>
            <StyledText text="Limited changes can be made once booked. For any permitted changes a change fee and any fare difference will apply. For the free passenger/s, the fare difference will be calculated from a $0 fare." />
          </StyledContainer>
        </Flex>
      </Box>
    </Box>
  );
};

Banner.propTypes = {
  slug: PropTypes.string,
};

export default Banner;
